// extracted by mini-css-extract-plugin
module.exports = {"container":"athlete-quote-stack_container__a3q6p","inner":"athlete-quote-stack_inner__9_lw3"};